import { InputConfig, validateEmail } from "@cpj-ai/panel-npm-package";
import ForgotPasswordLink from "@modules/Auth/components/ForgotPasswordLink";

export const defaultValues = {
  email: "",
  password: "",
};

export const inputConfigs: InputConfig[] = [
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Email:",
      placeholder: "Enter your email",
    },
    rules: {
      required: "Email is required",
      validate: (value) => {
        const emailResult = validateEmail(value);
        return emailResult.isValid ? true : emailResult.message;
      },
    },
  },
  {
    name: "password",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Password:",
      placeholder: "Enter your password",
      showStrengthLevel: false,
      description: <ForgotPasswordLink />,
    },
    rules: {
      required: "Password is required",
    },
  },
];
